// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `group-waiting h3,
group-waiting span.subheading {
  text-transform: uppercase;
  text-align: center;
}
group-waiting h3 {
  margin-bottom: 0.2em;
}
group-waiting span.subheading {
  display: block;
  margin-bottom: 1em;
}
group-waiting group-members {
  border: 1px solid var(--motes-dark);
}
group-waiting .description {
  min-height: 3em;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/group-waiting/group-waiting.component.scss"],"names":[],"mappings":"AACI;;EAEI,yBAAA;EACA,kBAAA;AAAR;AAGI;EACI,oBAAA;AADR;AAII;EACI,cAAA;EACA,kBAAA;AAFR;AAKI;EACI,mCAAA;AAHR;AAMI;EACI,eAAA;AAJR","sourcesContent":["group-waiting {\n    h3,\n    span.subheading {\n        text-transform: uppercase;\n        text-align: center;\n    }\n\n    h3 {\n        margin-bottom: 0.2em;\n    }\n\n    span.subheading {\n        display: block;\n        margin-bottom: 1em;\n    }\n\n    group-members {\n        border: 1px solid var(--motes-dark);\n    }\n\n    .description {\n        min-height: 3em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
